<template>
  <div>
    <div id="chart-container" class="by-value-roadmap">
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" id="cp-by-value-roadmap-e-chart" class="chart-row">
        <profile-chart-header
            :title="'Road Map | ' + titleSuffix"            
            :content-list="contentList"
            :content-name="'Road Map'"
            :display-download-comments="true"
            :display="this.$parent.getDisplayView() && getDisplayView()"
            :input-display-number-of-responses="false"
            :input-show-tooltip="eChartCriteria.showTooltip"
            :display-show-tooltip="false"
            :display-show-respondents="false"            
            @set-display-number-of-responses="setDisplayNumberOfResponses"
            @set-show-tooltip="setShowTooltip"
        /> 
        <div class="value-road-map-chart-display">
          <div class="buttons-and-chart d-flex">
            <chart-buttons
                  :display="true"
                  :snap-label="'Snap'"
                  :tooltip-configuration="snapChartTooltipConfig"
                  snap-container-id="value-road-map-display"
                  container-id="value-road-map-display"
                  :report-page-type-name="'Chart - Value Map'"
                  insight-modal-id="profile-by-value-roadmap-chart"
                >
            </chart-buttons>
          </div>
          <div id="value-road-map-display" class="d-flex">
                <div class="m-1">
                  <value-road-map v-show="this.noData == false"
                  :value-road-map-data="valueRoadMapData"
                  />
                  <div v-show="this.noData == true" class="no-data-for-chart mx-auto">
                    <div class="pb-2">Not enough data in your selection</div>
                    <div class="pb-2">exists to build a digital profile.</div>
                    <div class="pb-2">Try selecting a different set of chart criteria</div>
                    <div class="pb-2">or areas.</div>
                  </div>                
                </div>
                <value-road-map-display
                    v-show="this.noData == false"
                    :moatCompsData="moatCompsData"
                    :valueRoadMapDisplayData="valueRoadMapDisplayData"
                  />
                
          </div>
        </div>          
      </div>      
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" :id="focusAreasTable.tableContainerId" :class="isInsiderUser ? 'chart-data hide-table-data' : 'chart-data'">
        <div v-show="isInsiderUser" class="overlay">
          <img class="overlay-inner" v-show="isInsiderUser" src="../../../assets/img/overlap.png" style="width: 50%"/>
        </div>
        <chart-data-table
          ref="focusAreasDataTable"
          v-show="this.$parent.getDisplayView() && getDisplayView()"
          :chart-data="this.focusAreasTable.data"
          :display-direction="'vertical'"
          :data-container-id="focusAreasTable.tableContainerId"
          :container-id="'cp-by-value-roadmap-chart'"
          :is-saved-card="$parent.clientChart.clientChartId != 0"           
          :content-list="this.pageContentForValueRoadMap"
          :column-defs="this.chart.columnDefs"
          :table-class="'table display row-border table-hover'"
          :table-width="'auto'"
          :report-page-type-name="'Table - Value Map'"
          :insight-modal-id="'profile-by-value-roadmap-table'"
          :table-title="this.focusAreasTable.title"
          :use-alternate-title="true"
          :inputDownloadFileName="'Road Map - ' + titleSuffix"            
          :effort-list="needsEffortList"
          :display-profile-strength-legend="$parent.displayProfileStrengthLegend"
          @display-initiatives="$parent.displayInitiativesForProfileTable"
          @go-to-explore="$parent.goToExploreForProfileTable"
        ></chart-data-table>
      </div>
    </div>
    <div v-for="(pageContent, idxPageContent) in pageContentForValueRoadMap" v-bind:key="idxPageContent">
      <modal :modal-id="pageContent.title" :modal-title="pageContent.title" :modal-content="pageContent.contentText" />
    </div>
    
    <insights
      ref="insightsChart"
      :modal-name="'profile-by-value-roadmap-chart'"
      :report-page-type-name="'Chart - Value Map'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsTable"
      :modal-name="'profile-by-value-roadmap-table'"
      :report-page-type-name="'Table - Value Map'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
  </div>
</template>
<script>
import $ from "jquery";
import ProfileChartHeader from "../../../components/echarts/ProfileChartHeader.vue";
import ValueRoadMap from "../../../components/chart/ValueRoadMap.vue";
import ChartButtons from "../../../components/chart/ChartButtons.vue";
import ChartCompanyMixins from "../../../mixins/ChartCompanyMixins.vue";
import ChartService from "../../../services/chart.service";
import ErrorService from "../../../services/error.service";
import AdminService from "../../../services/admin.service";
import TableService from "../../../services/table.service";
import ReportService from "../../../services/report.service";
import ContentService from "../../../services/content.service";
import NeedsService from "../../../services/needs.service";
import ValueRoadMapDisplay from "../../../components/chart/ValueRoadMapDisplay.vue";

export default {
  name: "ByValueRoadmap",
  mixins: [ChartCompanyMixins],
  components: { ProfileChartHeader,ChartButtons,ValueRoadMap,ValueRoadMapDisplay},
  //components: { ProfileChartHeader,ChartButtons,ValueRoadMap},
  data() {
    return {
      displayType: "value-roadmap",
      noData: true,
      pageContentForValueRoadMap: [],
      moatCompsData:{
        noData: true,
        notEnoughData: true,
        rankingsByCompany: [],
        rankingsByFramework: [],
      },
      needsEffortList: [],
      valueRoadMapDisplayData: [],
      valueRoadMapData: {
        metricData: {
          name: "",
          value: 0,
          metricDirection: ""
        },        
      },
      focusAreasTable: {
        id: "",
        data: {},
        title: '<div class="title"><h4 class="text-primary">Road Map</h4></div>',
        tableContainerId: "value_roadmap_focus_areas_data_container",
      },
      isMobile: false,
      titleSuffix: "",
    };
  },
  props: {
    chartData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    contentList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    surveyCode: function() {
      return this.$parent.$data.survey.surveyCode;
    },    

  },
  mounted() {},
  created() {
        ContentService.getPageContent("Value Roadmap", this.getPageContentByMoatsCallBack, this);
  },
  methods: {
    getPageContentByMoatsCallBack(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.pageContentForValueRoadMap = response.data.data;
      }
    },
    displayInsights(insightModalId, reportPageTypeName) {
      if (reportPageTypeName == "Chart - Value Map") {
        this.$refs.insightsChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsChart.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Table - Value Map") {
        this.$refs.insightsTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsTable.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      }
    },
    async processChartData() {
      try {
        this.$parent.pageContent.push(...this.contentList);
        this.pageContentForValueRoadMap.push(...this.contentList);

        this.chart = ChartService.getChartAttributes("Profile By Value Roadmap");
        let needsData = JSON.parse(JSON.stringify(this.chartData[0]));        
        let otherData = needsData["otherData"];
        let titleSuffix = otherData["titleSuffix"];
        if (typeof titleSuffix != "undefined" && titleSuffix != null && titleSuffix != "") {
          this.titleSuffix = titleSuffix;
        }
        this.needsEffortList = otherData["effortList"];
        let valueRoadmapTableResults = otherData["valueRoadmapTableResults"];
        this.moatCompsData = JSON.parse(JSON.stringify(otherData["moatCompsData"]));
        this.valueRoadMapDisplayData = JSON.parse(JSON.stringify(otherData["valueRoadMapDisplayData"]));
        this.valueRoadMapData = JSON.parse(JSON.stringify(valueRoadmapTableResults));
        this.valueRoadMapData.metricData = {};
        let containerId = needsData["containerId"];
        this.table.id = containerId;
        
        let copyOfChartData = JSON.parse(JSON.stringify(needsData));
        let columns = needsData["cols"];
        let isPositiveCorrelation = otherData["isPositiveCorrelation"];
        this.chart.columnDefs = this.buildColumns(columns,isPositiveCorrelation);

        this.focusAreasTable.id = containerId;
        this.focusAreasTable.data = copyOfChartData;
        this.$parent.setChartResults(needsData.companyList);
        let needsList = otherData["needsList"];
        NeedsService.setFunctionalNeedsList(needsList);
        let valueRoadMapId = otherData["valueRoadMapId"];
        this.$emit("set-value-roadmap-id", valueRoadMapId);
        
        this.noData = valueRoadmapTableResults["noData"];
        this.$parent.$data.criteriaResultsList = AdminService.removeByName(needsData.criteriaList, "Competitor");
        let showRelationshipStrength = this.$parent.$data.criteriaResultsList.find(item => item.name === "Show Relative Strength");
        if (typeof showRelationshipStrength != "undefined" && showRelationshipStrength.displayValue == "Yes") {
          this.$parent.displayProfileStrengthLegend = true;
        } else {
          this.$parent.displayProfileStrengthLegend = false;
        }

        this.buildClientChart();
        this.setDisplayView(true);
        this.$parent.setDisplayView(true);

        const vm = this;
        setTimeout(function () {
            vm.saveReportPage();
            vm.saveProfileDataTable();
        }, 1500);

      } catch (err) {
        ErrorService.processException("ByValueRoadmap.displayChartCallback", err, "chart", this);
      }
    },
    buildColumns(columns,isPositiveCorrelation = true){
      let returnColumns = [
          TableService.getOrderSequence(),
          {
            targets: [0],
            className: "dt-left",
            width: 120,
            render: function(data, type, row, meta) {
              return data;
            }
          },
          {
            targets: [1],
            className: "dt-left",
            width: 190,
            render: function(data, type, row, meta) {
              if (data == null){
                return "";
              }
              var parameters = meta.settings.oInit.columnDefs[meta.col].parameters;
              let originalData = data;
              data = data.length > 40 ? data.substr(0, 40) + "…" : data;
              let displayData = data;
              let includeToolTip = data.length > 40;

              if (type === "display"  && originalData != "Functional Average" && originalData != "Emotional Average"  && originalData != "Overall Average"
                && originalData != "Focus Area Average" && originalData != "Other Area Average"
              ) {
                let isEmotional = NeedsService.isEmotionalNeed(data);
                let needType = isEmotional ? "emotional" : "functional";
                let fieldNumber = NeedsService.getNeedNumber(data, needType);
                if (fieldNumber == 0) {
                  fieldNumber = meta.row + 1;
                }
                let needName = isEmotional ? "Emotional Need " : "Functional Need ";
                needName += fieldNumber;
                data = '<span class="popUpForRoadMapInitiatives"  data-modal-name="' + needName + '" data-need-number="' + fieldNumber + '" data-need-type="' + needType + '"><img src="/img/icons/wratings-mini-logo.png" class="icon-table-view"/></span>';
                data += ' <span class="popUpForExplorer"  data-modal-name="' + needName + '" data-need-number="' + fieldNumber + '" data-need-type="' + needType + '"><img src="/img/magnifying-glass-dollar.svg" class="icon-table-view"/></span>';                
                if (includeToolTip) {
                  data += '<span data-toggle="tooltip" title="' + originalData + '">' + displayData + "</span>";
                } else {
                  data += displayData;
                }
              }
              return data;
            }
          },
          TableService.getNumericTableAttributeDefaultBlank([2], "dt-right", 50),
          TableService.getNumericTableAttributeDefaultBlank([3], "dt-right", 50),
          TableService.getNumericTableAttributeDefaultBlank([4], "dt-right ", 50),
      ];
      let position = 0;
      columns.forEach(function(column) {
        if (position >= 5){
          if (column.id == "pricing-power"){
            returnColumns.push(TableService.getPercentTableAttribute([position], "dt-right", 50, 2)); // Pricing Power
          } else if (column.label == "Relative Strength"){
            returnColumns.push(TableService.getRelativeStrengthTableAttribute([position], "dt-right", 50, 2,isPositiveCorrelation)); // Relative Strength
          } else if (column.label == "Metric" || column.label == "Growth Ideas" || column.label == "Road Map Initiatives") {
            returnColumns.push(TableService.getMetricTableAttribute([position], "dt-left", 200, 2));
          } else {
            returnColumns.push(TableService.getNumericTableAttribute([position], "dt-right", 50));
          }
        }
        position++;
      });
      returnColumns.push(TableService.getNumericTableAttribute(["_all"], "dt-right", 50));      
      return returnColumns;
    },
    async saveProfileDataTable(){
      if (this.$parent.clientChart.clientChartId != 0 && this.isGenerateReportRunning()) {
        let vm = this;
        setTimeout(function() {
          ReportService.saveReportTableFile(vm.$refs.focusAreasDataTable.getTableData(), "Table - Value Map", vm.$parent.clientChart, vm.saveReportTableFileCallback,vm);
          ReportService.saveReportPage(vm.getReportTableContent("cp-by-value-roadmap-chart"),"Table - Value Map", vm.$parent.clientChart, vm.saveReportPageCallback, vm);
        }, 1200);        
      }
    },
    saveAllReportPages() {
        this.saveReportPage();
        this.saveProfileDataTable();
    },
    async saveReportPage() {
      if (this.$parent.clientChart.clientChartId != 0 && this.isGenerateReportRunning()) {
        let vm = this;
        setTimeout(async function () {
          let reportPageChart = $("#value-road-map-display");
          reportPageChart.addClass("word-cloud-display-container");
          let reportPageChartObject = reportPageChart[0];
          let imageReportPageChartContent = await vm.createChartImage(reportPageChartObject, false, true, 4,"pdf-content-image-word-cloud-width");
          await ReportService.saveReportPage(imageReportPageChartContent, "Chart - Value Map", vm.$parent.clientChart, vm.saveReportPageCallback, vm);
          await ReportService.saveReportPageFile(vm.imageUrl, "png", "Chart - Value Map", vm.$parent.clientChart, vm.saveReportPageCallback, vm);
        }, 1200);
      }
    },

  },
  watch: {
    surveyCode: function() {
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.$refs.eChart.clear();} catch(e){}
    },
    chartData: function() {
      if (this.$parent.isByValueRoadmap) {
        this.processChartData();
      } else {
        this.setDisplayView(false);
      }
    }
  }
};
</script>
